/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Support component names relative to this directory:
let componentRequireContext = require.context('components', true, /^(?!.*(__tests__|\.test\.|\.spec\.)).*\.(js|jsx|ts|tsx)$/);

// eslint-disable-next-line @typescript-eslint/no-var-requires
let ReactRailsUJS = require('react_ujs');

// Proxy the context to handle extensionless lookups which can happen with shakapacker
const componentContext = (name) => {
  try {
    return componentRequireContext(name);
  } catch (e) {
    const extensions = ['.tsx', '.ts', '.jsx', '.js'];
    for (const ext of extensions) {
      try {
        return componentRequireContext(name + ext);
      } catch (err) {
        // ignore
      }
    }
    throw e;
  }
};
componentContext.keys = componentRequireContext.keys;
componentContext.resolve = componentRequireContext.resolve;
componentContext.id = componentRequireContext.id;

ReactRailsUJS.useContext(componentContext);
